export default {
  orderStatus: (state) => state.orderStatus,
  stores: (state) => state.stores,
  storeWithLimits: (state) => state.storeWithLimits,
  generalSetting: (state) => state.generalSetting,
  getImageSlider: (state) => state.getImageSlider
}
